import {
  CalendarDays,
  Clapperboard,
  Clock,
  Home,
  Images,
  Mail,
  Paintbrush,
  Palette,
  Rows3,
  Sparkles,
} from 'lucide-react';
import { SECTION_EDITORS } from './sectionEditors';

/**
 * Single source of truth for the admin dashboard.
 * Adding a section = one entry here + one editor in sectionEditors.jsx. Nothing else changes.
 *
 * - id:        URL segment under /dashboard/
 * - stateKey:  key inside LandingPageContext (also the API section name)
 * - defaultKey: export name in data/defaultSections used by "Reset all"
 * - icon:      lucide-react component for the sidebar
 */
export const ADMIN_SECTIONS = [
  { id: 'hero', stateKey: 'hero', defaultKey: 'defaultHero', icon: Home },
  { id: 'first', stateKey: 'firstSection', defaultKey: 'defaultFirstSection', icon: Rows3 },
  { id: 'art', stateKey: 'artSection', defaultKey: 'defaultArtSection', icon: Palette },
  { id: 'now', stateKey: 'nowSection', defaultKey: 'defaultNowSection', icon: Clock },
  { id: 'gallery', stateKey: 'gallerySection', defaultKey: 'defaultGallerySection', icon: Images },
  { id: 'videos', stateKey: 'videosSection', defaultKey: 'defaultVideosSection', icon: Clapperboard },
  { id: 'events', stateKey: 'eventsSection', defaultKey: 'defaultEventsSection', icon: CalendarDays },
  { id: 'contact', stateKey: 'contactSection', defaultKey: 'defaultContactSection', icon: Mail },
  { id: 'new', stateKey: 'newSection', defaultKey: 'defaultNewSection', icon: Sparkles },
  { id: 'globalColors', stateKey: 'globalColors', defaultKey: 'defaultGlobalColors', icon: Paintbrush },
].map((section) => ({ ...section, Component: SECTION_EDITORS[section.id] }));

export const getAdminSection = (id) => ADMIN_SECTIONS.find((section) => section.id === id) || null;
